<ion-footer>
<!--  <ion-toolbar  *ngIf="exibirBotoes">-->
<!--    <ion-buttons slot="start">-->
<!--      <ion-button (click)="cancelar()">-->
<!--        <ion-icon name="arrow-back-outline"/>-->
<!--      </ion-button>-->
<!--    </ion-buttons>-->
<!--    <ion-buttons slot="end">-->
<!--      <ion-button color="success" (click)="save()" type="submit">-->
<!--        Salvar-->
<!--        <ion-icon slot="start" name="save"></ion-icon>-->
<!--      </ion-button>-->
<!--      <ion-button *ngIf="deletavel" color="danger" (click)="delete()">-->
<!--        Excluir-->
<!--        <ion-icon slot="start" name="trash"></ion-icon>-->
<!--      </ion-button>-->
<!--    </ion-buttons>-->

<!--  </ion-toolbar>-->
<!--  Baixando arquivos-->
<!--  <ion-progress-bar color="primary" type="determinate" [value]="0.37">-->
<!--    {{ 37 }}%-->
<!--  </ion-progress-bar>-->
</ion-footer>
